import { ApiClient } from '@/apiClient'
import type { Location } from '@/interfaces/Location'
import { ElNotification } from 'element-plus';
import * as Sentry from "@sentry/browser";

export class LocationService {
  apiClient = new ApiClient()

  async getLocations(): Promise<Location[]> {
    let locations: Location[] = []
    await this.apiClient.getLocations().then((response: any) => {
      if (response != undefined) {
        locations = response.data;
      } else {
        ElNotification({
          title: 'Error',
          message: 'Failed to get locations list. Please try again later.',
          type: 'error'
        })
      }
    }).catch((error: any) => {
      Sentry.captureException(error);
      ElNotification({
        title: 'Error',
        message: 'Failed to get locations list. Please try again later.',
        type: 'error'
      })
    });
    return locations;
  }

  async setLocation(id: string): Promise<void> {
    const response : any = await this.apiClient.setLocation(id);
    if (response != null)
      localStorage.setItem('access_token', response.data.token)
  }
}
